// extracted by mini-css-extract-plugin
export default {"addCardButton":"PaymentMethods_addCardButton__YQyMp","securityInfo":"PaymentMethods_securityInfo__o1XZ8","securityIcon":"PaymentMethods_securityIcon__3j3s0"};